import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "user-info-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "user-info-group"
}
const _hoisted_3 = { class: "user-info-label" }
const _hoisted_4 = {
  key: 1,
  class: "user-info-group"
}
const _hoisted_5 = {
  key: 0,
  class: "user-info-label"
}
const _hoisted_6 = {
  key: 1,
  class: "user-info-label"
}
const _hoisted_7 = {
  key: 2,
  class: "user-info-label"
}
const _hoisted_8 = {
  key: 3,
  class: "user-info-label"
}
const _hoisted_9 = { class: "user-info-group" }
const _hoisted_10 = {
  key: 0,
  class: "user-info-label"
}
const _hoisted_11 = {
  key: 1,
  class: "user-info-label"
}
const _hoisted_12 = { class: "action-buttons" }

import { useAuctionStore } from "@/stores/AuctionStore";
  import { IUserPopupData } from "@/models";
  import { computed, inject, reactive } from "vue";
  import { CustomerStatus } from "@/enum";
  import { trans } from "@/utils/trans";
  import apiClient from "@/services/api";
  import { useToast } from "primevue/usetoast";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'UserInfoPopup',
  props: {
    data: {}
  },
  emits: ["closeForm", "changeTitle", "setModalHeightAuto"],
  setup(__props: any, { emit: __emit }) {

  const toast = useToast();

  const emit = __emit;
  const props = __props;
  const auctionStore = useAuctionStore();
  const emitter = inject("emitter");

  const state = reactive({
    customer_status: props.data.user.customer_status,
    customer_is_muted: props.data.user.customer_is_muted,
    waitCSResponse: false,
    waitIMResponse: false
  });

  // eslint-disable-next-line no-undef
  const user = computed(() => {
    return props.data.user;
  });

  const address = computed(() => {
    const parts = [];
    let info = "";
    if (user?.value?.main_address?.address_state) {
      parts.push(user.value.main_address.address_state);
    }
    if (user?.value?.main_address?.address_zip) {
      parts.push(user.value.main_address.address_zip);
    }

    if (parts.length > 0) {
      info = `, ${parts.join(" ")}`;
    }

    return `${user?.value?.main_address?.address_city}${info}`;
  });

  const approveBtnText = computed(() => {
    return state.customer_status != CustomerStatus.APPROVED
      ? trans("live.user_list.popup.buttons.approve")
      : trans("live.user_list.popup.buttons.block");
  });

  const muteBtnText = computed(() => {
    return state.customer_is_muted
      ? trans("live.user_list.popup.buttons.unmute")
      : trans("live.user_list.popup.buttons.mute");
  });

  const onApproveBtn = () => {
    if (state.waitCSResponse) return;

    const href =
      auctionStore.routes[state.customer_status != CustomerStatus.APPROVED ? "live.users.approve" : "live.users.block"];
    state.waitCSResponse = true;
    apiClient
      .put(href, { userId: user.value.id })
      .then((response) => {
        if (response.data.status) {
          state.customer_status = response.data.customer_status;
          auctionStore.$patch((storeState) => {
            if (storeState.userData[user.value.id]) {
              storeState.userData[user.value.id].customer_status = state.customer_status;
            }
            const index = auctionStore.activeLot?.bidders.findIndex((item) => {
              return item.id === user.value.id;
            });
            if (index && index >= 0) {
              storeState.activeLot.bidders[index].customer_status = state.customer_status;
            }
          });
        }
        toast.add({
          severity: response.data.status ? "success" : "error",
          summary: trans("live.toast." + (response.data.status ? "success" : "error")),
          detail: response.data.message || trans("live.toast.unknown_error"),
          life: 6000
        });
      })
      .finally(() => (state.waitCSResponse = false));
  };

  const onMuteBtn = () => {
    if (state.waitIMResponse) return;

    const href = auctionStore.routes[state.customer_is_muted ? "live.users.unmute" : "live.users.mute"];
    state.waitIMResponse = true;
    apiClient
      .put(href, { userId: user.value.id })
      .then((response) => {
        if (response.data.status) {
          state.customer_is_muted = response.data.customer_is_muted;
          emitter?.emit("on:user-mute", { userId: user.value.id, customerIsMuted: state.customer_is_muted });
          auctionStore.$patch((storeState) => {
            if (storeState.userData[user.value.id]) {
              storeState.userData[user.value.id].customer_is_muted = state.customer_is_muted;
            }
            const index = auctionStore.activeLot?.bidders.findIndex((item) => {
              return item.id === user.value.id;
            });
            if (index && index >= 0) {
              storeState.activeLot.bidders[index].customer_is_muted = state.customer_is_muted;
            }
          });
        }
        toast.add({
          severity: response.data.status ? "success" : "error",
          summary: trans("live.toast." + (response.data.status ? "success" : "error")),
          detail: response.data.message || trans("live.toast.unknown_error"),
          life: 6000
        });
      })
      .finally(() => (state.waitIMResponse = false));
  };

  const onOpenChat = () => {
    emitter?.emit("on:user-message", user.value);
    emit("closeForm");
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (user.value.customer_id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, "ID: " + _toDisplayString(user.value.customer_id), 1)
        ]))
      : _createCommentVNode("", true),
    (user.value.main_address)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (user.value.main_address.address_street)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(user.value.main_address.address_street), 1))
            : _createCommentVNode("", true),
          (user.value.main_address.address_street2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(user.value.main_address.address_street2), 1))
            : _createCommentVNode("", true),
          (address.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(address.value), 1))
            : _createCommentVNode("", true),
          (user.value.main_address.country?.name)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(user.value.main_address.country.name), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      (user.value.main_address?.contact_phone)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(user.value.main_address?.contact_phone), 1))
        : _createCommentVNode("", true),
      (user.value.phone)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(user.value.phone), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("button", {
        onClick: onApproveBtn,
        class: _normalizeClass(['btn', state.customer_status === _unref(CustomerStatus).APPROVED ? 'btn-warn-outline' : 'btn-blue-outline'])
      }, _toDisplayString(approveBtnText.value), 3),
      _createElementVNode("button", {
        class: "btn btn-blue-outline",
        onClick: onMuteBtn
      }, _toDisplayString(muteBtnText.value), 1),
      _createElementVNode("button", {
        class: "btn btn-blue stage-b-item",
        onClick: onOpenChat
      }, _toDisplayString(_unref(trans)("live.user_list.popup.buttons.message")), 1)
    ])
  ]))
}
}

})